import * as userCoordinators from './adminUser'
import * as editCoordinators from './edit'

export default Object.freeze({
  ...editCoordinators,
  ...userCoordinators,
})
